import {ReactNode} from 'react'
import {Form} from 'react-bootstrap'
import Feedback from './Feedback'
import {FormikProps} from 'formik'
import Multiselect from 'multiselect-react-dropdown'

interface Props {
  required?: boolean
  formik: FormikProps<any> | any
  label?: string
  name: string
  option: any[]
  keyLabel?: string
  disabled?: boolean
  singleSelect?: boolean
  isCompany?: boolean
}

const FormSelectField = ({
  required,
  formik,
  label,
  name,
  option,
  keyLabel = 'name',
  singleSelect = false,
  disabled,
}: Props) => {
  return (
    <Form.Group className='mb-3'>
      <Form.Label>
        {label} {required && <span className='text-danger'>*</span>}
      </Form.Label>
      <Multiselect
        singleSelect={singleSelect}
        options={option}
        selectedValues={formik.values[name]}
        onSelect={(e) => formik.setFieldValue(name, e)}
        onRemove={(e) => formik.setFieldValue(name, e)}
        displayValue={keyLabel}
        className={`${formik.touched[name] && formik.errors[name] && 'invalid'}`}
        disable={disabled || formik.isSubmitting}
      />
      {formik.touched[name] && formik.errors[name] && (
        <Feedback>
          <>{formik.errors[name]}</>
        </Feedback>
      )}
    </Form.Group>
  )
}

FormSelectField.defaultProps = {
  type: 'select',
}

export default FormSelectField
